<template>
    <span class="badge badge-pill badge-info text-light">
        <span class="mr-2">{{ tag.name }}</span>
        <i class="fa fa-times" aria-hidden="true" @click="$emit('remove', tag.id)"></i>

        <input type="hidden" name="targets[]" :value="tag.id">
    </span>
</template>

<script>
export default {
    props: {
        tag: { type: Object, required: true }
    }
};
</script>

<style scoped>
.fa-times {
    cursor: pointer;
}
</style>
